import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import Pipeline from "../../../pipelines/components/Pipeline/Pipeline";

export default function ExecutingExportPipelineView({ theExport }) {
	const { t } = useTranslation();

	return (
		<>
			<Header as="h3">{t("pipeline", "Pipeline")}</Header>

			<Card fluid>
				<Card.Content>
					<Pipeline document={theExport} />
				</Card.Content>
			</Card>
		</>
	);
}
